// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2ayD-","title":"FrontImage_title__3WZvj"};